// src/module_pharmacy/StockReport.js
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../module_mechanics/Styles/FormList.css";
import {
    faBoxes, faBox, faSearch, faRefresh, faSpinner, faTimes,
    faChevronLeft, faChevronRight, faCalendar, faStore,
    faCheckCircle, faExclamationTriangle, faTimesCircle,
    faArrowUp, faArrowDown, faUndo, faFilePdf, faPrint,
    faFilter, faEyeSlash, faExchangeAlt, faChevronDown,
    faMinus, faPlus, faArrowsAlt, faExpand, faCompress,
    faCreditCard, faWarehouse, faTag, faHashtag, faBarcode,
    faList, faChartBar, faFileInvoice, faDownload, faEye,
    faBuilding, faPhone, faEnvelope, faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// ============================================
// TRANSLATOR FOR STOCK REPORT
// ============================================
const createStockReportTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) { }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) { }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Stock Report': 'اسٹاک رپورٹ',
                'Stock Report Details': 'اسٹاک رپورٹ کی تفصیلات',
                'Sr#': 'نمبر',
                'Product Name': 'پروڈکٹ کا نام',
                'Batch No': 'بیچ نمبر',
                'Product Code': 'پروڈکٹ کوڈ',
                'Purchase Qty': 'خریداری کی مقدار',
                'Sale Qty': 'فروخت کی مقدار',
                'Return Qty': 'واپسی کی مقدار',
                'Available Stock': 'دستیاب اسٹاک',
                'Unit': 'یونٹ',
                'Status': 'حالت',
                'Total Products': 'کل مصنوعات',
                'Total Purchases': 'کل خریداری',
                'Total Sales': 'کل فروخت',
                'Total Returns': 'کل واپسی',
                'In Stock': 'اسٹاک میں ہے',
                'Low Stock': 'کم اسٹاک',
                'Out of Stock': 'اسٹاک ختم',
                'Start Date': 'شروع کی تاریخ',
                'End Date': 'اختتامی تاریخ',
                'Search Products...': 'مصنوعات تلاش کریں...',
                'Refresh': 'ریفریش کریں',
                'Export PDF': 'پی ڈی ایف ایکسپورٹ کریں',
                'Print': 'پرنٹ کریں',
                'Loading Stock Report...': 'اسٹاک رپورٹ لوڈ ہو رہا ہے...',
                'No stock data available': 'کوئی اسٹاک ڈیٹا دستیاب نہیں',
                'Close': 'بند کریں',
                'Generated': 'تیار کردہ',
                'Showing': 'دکھا رہا ہے',
                'of': 'میں سے',
                'Previous': 'پچھلا',
                'Next': 'اگلا',
                'All': 'سب',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Please select a shop to view stock report': 'براہ کرم اسٹاک رپورٹ دیکھنے کے لیے شاپ منتخب کریں',
                'Switch Shop': 'شاپ تبدیل کریں',
                'Current': 'موجودہ',
                'Loading shops...': 'شاپس لوڈ ہو رہی ہیں...',
                'No shops available': 'کوئی شاپ دستیاب نہیں',
                'TOTALS': 'کل',
                'Stock Value': 'اسٹاک ویلیو',
                'Cost/Unit': 'لاگت/یونٹ',
                'Price/Unit': 'قیمت/یونٹ',
                'Generated at': 'تیار کردہ',
                'Report ID': 'رپورٹ آئی ڈی',
                'Shop': 'شاپ'
            },
            'ar': {
                'Stock Report': 'تقرير المخزون',
                'Stock Report Details': 'تفاصيل تقرير المخزون',
                'Sr#': 'رقم',
                'Product Name': 'اسم المنتج',
                'Batch No': 'رقم الدفعة',
                'Product Code': 'رمز المنتج',
                'Purchase Qty': 'كمية الشراء',
                'Sale Qty': 'كمية البيع',
                'Return Qty': 'كمية المرتجع',
                'Available Stock': 'المخزون المتاح',
                'Unit': 'الوحدة',
                'Status': 'الحالة',
                'Total Products': 'إجمالي المنتجات',
                'Total Purchases': 'إجمالي المشتريات',
                'Total Sales': 'إجمالي المبيعات',
                'Total Returns': 'إجمالي المرتجعات',
                'In Stock': 'متوفر',
                'Low Stock': 'مخزون منخفض',
                'Out of Stock': 'نفد المخزون',
                'Start Date': 'تاريخ البدء',
                'End Date': 'تاريخ الانتهاء',
                'Search Products...': 'بحث عن منتجات...',
                'Refresh': 'تحديث',
                'Export PDF': 'تصدير PDF',
                'Print': 'طباعة',
                'Loading Stock Report...': 'جارٍ تحميل تقرير المخزون...',
                'No stock data available': 'لا توجد بيانات مخزون متاحة',
                'Close': 'إغلاق',
                'Generated': 'تم الإنشاء',
                'Showing': 'عرض',
                'of': 'من',
                'Previous': 'السابق',
                'Next': 'التالي',
                'All': 'الكل',
                'No shop selected': 'لم يتم اختيار متجر',
                'Please select a shop to view stock report': 'الرجاء اختيار متجر لعرض تقرير المخزون',
                'Switch Shop': 'تبديل المتجر',
                'Current': 'الحالي',
                'Loading shops...': 'جارٍ تحميل المتاجر...',
                'No shops available': 'لا توجد متاجر متاحة',
                'TOTALS': 'الإجماليات',
                'Stock Value': 'قيمة المخزون',
                'Cost/Unit': 'التكلفة/الوحدة',
                'Price/Unit': 'السعر/الوحدة',
                'Generated at': 'تم الإنشاء في',
                'Report ID': 'معرف التقرير',
                'Shop': 'متجر'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) { }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) { }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        stockReport: 'Stock Report',
        stockReportDetails: 'Stock Report Details',
        srNo: 'Sr#',
        productName: 'Product Name',
        batchNo: 'Batch No',
        productCode: 'Product Code',
        purchaseQty: 'Purchase Qty',
        saleQty: 'Sale Qty',
        returnQty: 'Return Qty',
        availableStock: 'Available Stock',
        unit: 'Unit',
        status: 'Status',
        totalProducts: 'Total Products',
        totalPurchases: 'Total Purchases',
        totalSales: 'Total Sales',
        totalReturns: 'Total Returns',
        inStock: 'In Stock',
        lowStock: 'Low Stock',
        outOfStock: 'Out of Stock',
        startDate: 'Start Date',
        endDate: 'End Date',
        searchProducts: 'Search Products...',
        refresh: 'Refresh',
        exportPDF: 'Export PDF',
        print: 'Print',
        loadingStockReport: 'Loading Stock Report...',
        noStockData: 'No stock data available',
        close: 'Close',
        generated: 'Generated',
        showing: 'Showing',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        all: 'All',
        noShopSelected: 'No shop selected',
        selectShop: 'Please select a shop to view stock report',
        switchShop: 'Switch Shop',
        current: 'Current',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        totals: 'TOTALS',
        stockValue: 'Stock Value',
        costPerUnit: 'Cost/Unit',
        sellPerUnit: 'Price/Unit',
        generatedAt: 'Generated at',
        reportId: 'Report ID',
        shop: 'Shop'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const stockReportTranslator = createStockReportTranslator();

// ============================================
// TOAST NOTIFICATION
// ============================================
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };
    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations?.success || 'Success';
            case 'error': return translations?.error || 'Error';
            case 'warning': return translations?.warning || 'Warning';
            default: return '';
        }
    };
    if (!toast.show) return null;
    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon"><FontAwesomeIcon icon={getIconForType(toast.type)} /></div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// ============================================
// SHOP SELECTOR MODAL
// ============================================
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozlistui-modal-overlay" onClick={onClose}>
            <div className="ozlistui-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozlistui-close-btn" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozlistui-modal-body">
                    {loading ? (
                        <div className="ozlistui-loading-shops">
                            <div className="ozlistui-loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="ozlistui-no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="ozlistui-shop-list">
                            {shops.map((shop) => (
                                <div
                                    key={shop.shop_id}
                                    className={`ozlistui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozlistui-active' : ''}`}
                                    onClick={() => onSelectShop(shop)}
                                >
                                    <div className="ozlistui-shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="ozlistui-shop-item-details">
                                        <div className="ozlistui-shop-item-name">{shop.shop_name}</div>
                                        <div className="ozlistui-shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="ozlistui-shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// ============================================
// MAIN STOCK REPORT COMPONENT
// ============================================
const StockReport = () => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    
    // State
    const [stockData, setStockData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);
    const [summary, setSummary] = useState({});
    const [businessInfo, setBusinessInfo] = useState({});
    
    // Language & Theme
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [translations, setTranslations] = useState({});
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        progress: 100
    });
    
    const toastTimerRef = useRef(null);
    const isMountedRef = useRef(true);

    // ============================================
    // TRANSLATIONS
    // ============================================
    useEffect(() => {
        const loadTrans = async (lang) => {
            const trans = await stockReportTranslator.getTranslations(lang);
            setTranslations(trans);
        };
        
        const onStorage = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTrans(lang);
            }
        };
        
        const onLangChange = (e) => {
            const newLang = e.detail?.language;
            if (newLang && newLang !== currentLanguage) {
                setCurrentLanguage(newLang);
                loadTrans(newLang);
            }
        };
        
        loadTrans(currentLanguage);
        window.addEventListener('storage', onStorage);
        window.addEventListener('languageChanged', onLangChange);
        
        return () => {
            window.removeEventListener('storage', onStorage);
            window.removeEventListener('languageChanged', onLangChange);
        };
    }, [currentLanguage]);

    // ============================================
    // DARK MODE
    // ============================================
    useEffect(() => {
        const syncDark = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);
            const container = document.querySelector('.ozlistui-container');
            if (container) {
                if (isDark) container.classList.add('ozlistui-dark');
                else container.classList.remove('ozlistui-dark');
            }
        };
        syncDark();
        const onStorage = (e) => {
            if (e.key === 'ourzest_darkMode') {
                const isDark = e.newValue === 'true';
                setDarkMode(isDark);
                const container = document.querySelector('.ozlistui-container');
                if (container) {
                    if (isDark) container.classList.add('ozlistui-dark');
                    else container.classList.remove('ozlistui-dark');
                }
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    // ============================================
    // THEME
    // ============================================
    useEffect(() => {
        const applyTheme = (color) => {
            if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
            document.documentElement.style.setProperty('--ozlistui-primary', color);
            document.documentElement.style.setProperty('--ozlistui-primary-dark', color);
            document.documentElement.style.setProperty('--ozlistui-primary-light', color);
        };
        applyTheme(localStorage.getItem('ourzest_theme') || '#6366f1');
        const onStorage = (e) => {
            if (e.key === 'ourzest_theme') applyTheme(e.newValue || '#6366f1');
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    // ============================================
    // RTL
    // ============================================
    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
    useEffect(() => {
        const container = document.querySelector('.ozlistui-container');
        if (container) {
            if (isRTL) {
                container.classList.add('ozlistui-rtl');
                container.classList.remove('ozlistui-ltr');
            } else {
                container.classList.add('ozlistui-ltr');
                container.classList.remove('ozlistui-rtl');
            }
        }
        document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
        document.body.dir = isRTL ? 'rtl' : 'ltr';
    }, [isRTL]);

    // ============================================
    // TOAST
    // ============================================
    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message, progress: 100 });
        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            setToast(prev => ({ ...prev, progress: Math.max(0, (timeLeft / 3) * 100) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);
        toastTimerRef.current = timer;
    }, []);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // ============================================
    // FETCH BUSINESS INFO
    // ============================================
    const fetchBusinessInfo = useCallback(async () => {
        if (!user?.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/get_business_info.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_business_info', username: user.username })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setBusinessInfo({
                    businessname: data.businessname || '',
                    bussinesslogo: data.bussinesslogo || '',
                    businessaddress: data.businessaddress || '',
                    fullname: data.fullname || '',
                    email: data.email || '',
                    phonenumber: data.phonenumber || ''
                });
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
        }
    }, [user]);

    // ============================================
    // FETCH AVAILABLE SHOPS
    // ============================================
    const fetchAvailableShops = useCallback(async () => {
        if (!user) return;
        setLoadingShops(true);
        try {
            const shopsData = await getShopsForSwitch();
            if (isMountedRef.current) setAvailableShops(shopsData.shops || []);
        } catch (error) {
            console.error('Error loading shops:', error);
            if (isMountedRef.current) setAvailableShops([]);
        } finally {
            if (isMountedRef.current) setLoadingShops(false);
        }
    }, [user, getShopsForSwitch]);

    // ============================================
    // FETCH STOCK REPORT
    // ============================================
   // In fetchStockReport function, change the fetch call to:

const fetchStockReport = useCallback(async () => {
    if (!currentShop || !user) {
        setLoading(false);
        return;
    }

    setLoading(true);
    try {
        // Build form data instead of JSON
        const formData = new URLSearchParams();
        formData.append('action', 'get_stock_report');
        formData.append('shop_id', currentShop.shop_id);
        formData.append('username', user.username);
        if (startDate) formData.append('start_date', startDate);
        if (endDate) formData.append('end_date', endDate);
        if (searchTerm) formData.append('search', searchTerm);

        const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/stockreport.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData.toString()
        });

        const data = await response.json();

        if (data.status === 'success') {
            setStockData(data.data || []);
            setSummary(data.summary || {});
        } else {
            showToast('error', data.message || 'Failed to load stock report');
        }
    } catch (error) {
        console.error('Error fetching stock report:', error);
        showToast('error', 'Failed to load stock report');
    } finally {
        setLoading(false);
    }
}, [currentShop, user, startDate, endDate, searchTerm, showToast]);

    // ============================================
    // INITIAL LOAD
    // ============================================
    useEffect(() => {
        if (user && currentShop) {
            fetchStockReport();
            fetchBusinessInfo();
            fetchAvailableShops();
        } else {
            setLoading(false);
        }
    }, [user, currentShop]);

    // ============================================
    // HANDLE SHOP SWITCH
    // ============================================
    const handleSwitchShop = useCallback(async (shop) => {
    try {
        const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
        if (success) {
            showToast('success', 'Shop switched successfully');
            setCurrentPage(1);
            setShowShopSelector(false);
            // ❌ REMOVE THIS LINE - useEffect will handle it
            // fetchStockReport();
        } else {
            showToast('error', 'Failed to switch shop');
        }
    } catch (error) {
        console.error('Error switching shop:', error);
        showToast('error', 'Failed to switch shop');
    }
}, [switchShop, showToast]); // ✅ Remove fetchStockReport from dependencies

    // ============================================
    // PAGINATION
    // ============================================
    const pagination = useMemo(() => {
        const totalPages = Math.ceil(stockData.length / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentData = stockData.slice(startIndex, endIndex);
        return { totalPages, startIndex, endIndex, currentData };
    }, [stockData, currentPage, itemsPerPage]);

    const handlePageChange = useCallback((page) => {
        if (page >= 1 && page <= pagination.totalPages) setCurrentPage(page);
    }, [pagination.totalPages]);

    // ============================================
    // FORMAT HELPERS
    // ============================================
    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return 'Rs. 0.00';
        return `Rs. ${parseFloat(amount).toFixed(2)}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return date.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
        } catch { return dateString; }
    };

    const formatDateFull = (dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return date.toLocaleString('en-IN', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
        } catch { return dateString; }
    };

    const getStockStatus = (quantity, alert) => {
        const qty = parseFloat(quantity) || 0;
        const alertQty = parseFloat(alert) || 5;
        if (qty <= 0) return { status: 'out-of-stock', text: translations.outOfStock || 'Out of Stock', color: '#ef4444' };
        if (qty <= alertQty) return { status: 'low-stock', text: translations.lowStock || 'Low Stock', color: '#f59e0b' };
        return { status: 'in-stock', text: translations.inStock || 'In Stock', color: '#10b981' };
    };

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text).replace(/[&<>]/g, function(m) {
            if (m === '&') return '&amp;';
            if (m === '<') return '&lt;';
            if (m === '>') return '&gt;';
            return m;
        });
    };

    // ============================================
    // EXPORT TO PDF
    // ============================================
    const exportToPDF = useCallback(async () => {
        if (!stockData || stockData.length === 0) {
            showToast('warning', translations.noStockData || 'No data to export');
            return;
        }

        setPdfLoading(true);
        try {
            const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4', compress: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const rowsPerPage = 18;
            const totalPages = Math.ceil(stockData.length / rowsPerPage);
            const isRTLDir = isRTL;

            const renderPage = async (pageData, pageNum) => {
                return new Promise((resolve) => {
                    const container = document.createElement('div');
                    container.style.width = '1200px';
                    container.style.padding = '15px 20px';
                    container.style.backgroundColor = '#ffffff';
                    container.style.color = '#1f2937';
                    container.style.fontFamily = "'Segoe UI', 'Helvetica Neue', Arial, sans-serif";
                    container.style.position = 'absolute';
                    container.style.left = '-9999px';
                    container.style.top = '0';
                    container.style.direction = isRTLDir ? 'rtl' : 'ltr';

                    const shopName = businessInfo?.businessname || currentShop?.shop_name || translations.stockReport || 'Stock Report';

                    let tableHTML = `
                        <div style="margin-bottom: 10px; text-align: center;">
                            <h1 style="font-size: 18px; font-weight: 700; color: #1f2937; margin: 0;">${escapeHtml(shopName)}</h1>
                            ${businessInfo?.businessaddress ? `<p style="font-size: 9px; color: #6b7280; margin: 2px 0;">${escapeHtml(businessInfo.businessaddress)}</p>` : ''}
                            ${businessInfo?.phonenumber ? `<p style="font-size: 9px; color: #6b7280; margin: 2px 0;">📞 ${escapeHtml(businessInfo.phonenumber)}</p>` : ''}
                            <div style="margin: 6px 0;">
                                <span style="font-size: 10px; font-weight: 600; color: #4b5563;">${translations.stockReport || 'Stock Report'}</span>
                                <span style="font-size: 9px; color: #6b7280; margin-left: 10px;">${translations.generated || 'Generated'}: ${formatDateFull(new Date().toISOString())}</span>
                            </div>
                            ${(startDate || endDate || searchTerm) ? `
                            <div style="font-size: 8px; color: #6b7280; margin: 4px 0; padding: 4px 10px; background: #f3f4f6; display: inline-block;">
                                ${startDate ? `${translations.startDate || 'Start'}: ${formatDate(startDate)}` : ''}
                                ${endDate ? ` | ${translations.endDate || 'End'}: ${formatDate(endDate)}` : ''}
                                ${searchTerm ? ` | ${translations.searchProducts || 'Search'}: "${escapeHtml(searchTerm)}"` : ''}
                            </div>
                            ` : ''}
                            <hr style="border: 1px solid #e5e7eb; margin: 6px 0;">
                        </div>
                        <table style="width: 100%; border-collapse: collapse; font-size: 8px; margin-top: 4px;">
                            <thead>
                                <tr>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: center; border: 0.5px solid #d1d5db; width: 5%;">${translations.srNo || 'Sr#'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: left; border: 0.5px solid #d1d5db; width: 18%;">${translations.productName || 'Product'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: center; border: 0.5px solid #d1d5db; width: 10%;">${translations.batchNo || 'Batch'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: center; border: 0.5px solid #d1d5db; width: 10%;">${translations.productCode || 'Code'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: right; border: 0.5px solid #d1d5db; width: 10%;">${translations.purchaseQty || 'Purchase'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: right; border: 0.5px solid #d1d5db; width: 10%;">${translations.saleQty || 'Sale'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: right; border: 0.5px solid #d1d5db; width: 10%;">${translations.returnQty || 'Return'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: right; border: 0.5px solid #d1d5db; width: 12%;">${translations.availableStock || 'Available'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: center; border: 0.5px solid #d1d5db; width: 8%;">${translations.unit || 'Unit'}</th>
                                    <th style="padding: 4px 4px; background: #f9fafb; color: #1f2937; font-weight: 600; text-align: center; border: 0.5px solid #d1d5db; width: 10%;">${translations.status || 'Status'}</th>
                                </tr>
                            </thead>
                            <tbody>
                    `;

                    pageData.forEach((item, idx) => {
                        const status = getStockStatus(item.available_stock, 5);
                        const isEven = idx % 2 === 0;
                        const bgColor = isEven ? '#ffffff' : '#f9fafb';

                        tableHTML += `
                            <tr style="background: ${bgColor}; border-bottom: 0.5px solid #e5e7eb;">
                                <td style="padding: 3px 4px; text-align: center; border: 0.5px solid #e5e7eb;">${(pageNum - 1) * rowsPerPage + idx + 1}</td>
                                <td style="padding: 3px 4px; text-align: left; font-weight: 500; border: 0.5px solid #e5e7eb;">${escapeHtml(item.product_name || '-')}</td>
                                <td style="padding: 3px 4px; text-align: center; font-family: monospace; border: 0.5px solid #e5e7eb;">${escapeHtml(item.batch_no || '-')}</td>
                                <td style="padding: 3px 4px; text-align: center; font-family: monospace; border: 0.5px solid #e5e7eb;">${escapeHtml(item.product_code || '-')}</td>
                                <td style="padding: 3px 4px; text-align: right; color: #3b82f6; font-weight: 600; border: 0.5px solid #e5e7eb;">${parseFloat(item.purchase_qty || 0).toFixed(2)}</td>
                                <td style="padding: 3px 4px; text-align: right; color: #f59e0b; font-weight: 600; border: 0.5px solid #e5e7eb;">${parseFloat(item.sale_qty || 0).toFixed(2)}</td>
                                <td style="padding: 3px 4px; text-align: right; color: #8b5cf6; font-weight: 600; border: 0.5px solid #e5e7eb;">${parseFloat(item.return_qty || 0).toFixed(2)}</td>
                                <td style="padding: 3px 4px; text-align: right; font-weight: 700; color: ${status.color}; border: 0.5px solid #e5e7eb;">${parseFloat(item.available_stock || 0).toFixed(2)}</td>
                                <td style="padding: 3px 4px; text-align: center; border: 0.5px solid #e5e7eb;">${escapeHtml(item.unit_of_measure || 'piece')}</td>
                                <td style="padding: 3px 4px; text-align: center; border: 0.5px solid #e5e7eb;">
                                    <span style="background: ${status.color}20; color: ${status.color}; padding: 2px 8px; font-size: 7px; font-weight: 600; border-radius: 0;">${status.text}</span>
                                </td>
                            </tr>
                        `;
                    });

                    // Empty rows
                    const emptyRows = rowsPerPage - pageData.length;
                    for (let i = 0; i < emptyRows; i++) {
                        tableHTML += `
                            <tr style="background: ${(pageData.length + i) % 2 === 0 ? '#ffffff' : '#f9fafb'}; border-bottom: 0.5px solid #e5e7eb;">
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                                <td style="padding: 3px 4px; border: 0.5px solid #e5e7eb;">&nbsp;</td>
                            </tr>
                        `;
                    }

                    tableHTML += `
                            </tbody>
                            <tfoot>
                                <tr style="background: #f3f4f6; font-weight: 700;">
                                    <td colspan="4" style="padding: 4px 4px; text-align: right; border: 0.5px solid #d1d5db;">${translations.totals || 'TOTALS'}</td>
                                    <td style="padding: 4px 4px; text-align: right; color: #3b82f6; border: 0.5px solid #d1d5db;">${pageData.reduce((sum, item) => sum + parseFloat(item.purchase_qty || 0), 0).toFixed(2)}</td>
                                    <td style="padding: 4px 4px; text-align: right; color: #f59e0b; border: 0.5px solid #d1d5db;">${pageData.reduce((sum, item) => sum + parseFloat(item.sale_qty || 0), 0).toFixed(2)}</td>
                                    <td style="padding: 4px 4px; text-align: right; color: #8b5cf6; border: 0.5px solid #d1d5db;">${pageData.reduce((sum, item) => sum + parseFloat(item.return_qty || 0), 0).toFixed(2)}</td>
                                    <td style="padding: 4px 4px; text-align: right; color: #ef4444; border: 0.5px solid #d1d5db;">${pageData.reduce((sum, item) => sum + parseFloat(item.available_stock || 0), 0).toFixed(2)}</td>
                                    <td colspan="2" style="border: 0.5px solid #d1d5db;"></td>
                                </tr>
                            </tfoot>
                        </table>
                        <div style="text-align: center; font-size: 8px; color: #9ca3af; margin-top: 8px; padding-top: 4px; border-top: 1px solid #e5e7eb;">
                            ${translations.page || 'Page'} ${pageNum} ${translations.of || 'of'} ${totalPages} | ${translations.generatedAt || 'Generated at'}: ${formatDateFull(new Date().toISOString())}
                        </div>
                    `;

                    container.innerHTML = tableHTML;
                    document.body.appendChild(container);
                    html2canvas(container, { scale: 2, backgroundColor: '#ffffff', logging: false }).then(canvas => {
                        document.body.removeChild(container);
                        resolve(canvas);
                    }).catch(() => {
                        document.body.removeChild(container);
                        resolve(null);
                    });
                });
            };

            for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
                const startIdx = (pageNum - 1) * rowsPerPage;
                const endIdx = Math.min(pageNum * rowsPerPage, stockData.length);
                const pageData = stockData.slice(startIdx, endIdx);
                const canvas = await renderPage(pageData, pageNum);
                if (canvas) {
                    if (pageNum > 1) pdf.addPage();
                    const imgWidth = pageWidth - 20;
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;
                    pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 5, imgWidth, imgHeight);
                }
            }

            const fileName = `Stock_Report_${currentShop?.shop_name?.replace(/[^a-z0-9]/gi, '_') || 'Export'}_${new Date().toISOString().split('T')[0]}.pdf`;
            pdf.save(fileName);
            showToast('success', `${translations.stockReport || 'Stock Report'} exported successfully! ${stockData.length} ${translations.totalProducts || 'products'}`);
        } catch (error) {
            console.error('PDF Error:', error);
            showToast('error', 'Error generating PDF');
        } finally {
            setPdfLoading(false);
        }
    }, [stockData, currentShop, translations, showToast, isRTL, startDate, endDate, searchTerm, businessInfo, formatDateFull]);

    // ============================================
    // HANDLE PRINT
    // ============================================
    const handlePrint = () => {
        window.print();
    };

    // ============================================
    // RENDER
    // ============================================
    const renderContent = () => {
        if (loading) {
            return (
                <div className="ozlistui-loading-container">
                    <div className="ozlistui-loading-spinner"></div>
                    <p>{translations.loadingStockReport || 'Loading Stock Report...'}</p>
                </div>
            );
        }

        if (!currentShop) {
            return (
                <div className="ozlistui-no-shop-container">
                    <div className="ozlistui-no-shop-message">
                        <FontAwesomeIcon icon={faStore} />
                        <h3>{translations.noShopSelected || 'No Shop Selected'}</h3>
                        <p>{translations.selectShop || 'Please select a shop to view stock report'}</p>
                        <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => setShowShopSelector(true)}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span>{translations.switchShop || 'Switch Shop'}</span>
                        </button>
                    </div>
                </div>
            );
        }

        if (stockData.length === 0) {
            return (
                <div className="oztransui-no-data">
                    <FontAwesomeIcon icon={faBoxes} />
                    <p>{translations.noStockData || 'No stock data available'}</p>
                </div>
            );
        }

        // Calculate summary totals
        const totalPurchaseQty = stockData.reduce((sum, item) => sum + (item.purchase_qty || 0), 0);
        const totalSaleQty = stockData.reduce((sum, item) => sum + (item.sale_qty || 0), 0);
        const totalReturnQty = stockData.reduce((sum, item) => sum + (item.return_qty || 0), 0);
        const totalAvailableStock = stockData.reduce((sum, item) => sum + (item.available_stock || 0), 0);

        return (
            <>
                {/* Stock Report Filters */}
                <div className="ozlistui-filters-section">
                    <div className="ozlistui-filters-row">
                        <div className="ozlistui-filter-group">
                            <div className="ozlistui-floating-wrapper">
                                <input
                                    type="date"
                                    id="stockStartDate"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    placeholder=" "
                                />
                                <label htmlFor="stockStartDate">
                                    <FontAwesomeIcon icon={faCalendar} />
                                    {translations.startDate || 'Start Date'}
                                </label>
                            </div>
                        </div>
                        <div className="ozlistui-filter-group">
                            <div className="ozlistui-floating-wrapper">
                                <input
                                    type="date"
                                    id="stockEndDate"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    placeholder=" "
                                />
                                <label htmlFor="stockEndDate">
                                    <FontAwesomeIcon icon={faCalendar} />
                                    {translations.endDate || 'End Date'}
                                </label>
                            </div>
                        </div>
                        <div className="ozlistui-filter-group ozlistui-search-filter">
                            <div className="ozlistui-floating-wrapper">
                                <input
                                    type="text"
                                    id="stockSearch"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder=" "
                                    onKeyDown={(e) => { if (e.key === 'Enter') fetchStockReport(); }}
                                />
                                <label htmlFor="stockSearch">
                                    <FontAwesomeIcon icon={faSearch} />
                                    {translations.searchProducts || 'Search Products...'}
                                </label>
                            </div>
                        </div>
                        <div className="ozlistui-filter-group">
                            <button className="ozlistui-refresh-btn" onClick={fetchStockReport}>
                                <FontAwesomeIcon icon={faRefresh} />
                                <span className="ozlistui-btn-text">{translations.refresh || 'Refresh'}</span>
                            </button>
                        </div>
                        <div className="ozlistui-filter-group">
                            <button
                                className="ozlistui-refresh-btn"
                                onClick={exportToPDF}
                                disabled={stockData.length === 0 || pdfLoading}
                                style={{ background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: 'white' }}
                            >
                                {pdfLoading ? <div className="ozlistui-btn-spinner-small"></div> : <FontAwesomeIcon icon={faFilePdf} />}
                                <span className="ozlistui-btn-text">{translations.exportPDF || 'Export PDF'}</span>
                            </button>
                        </div>
                        <div className="ozlistui-filter-group">
                            <button
                                className="ozlistui-refresh-btn"
                                onClick={handlePrint}
                                style={{ background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', color: 'white' }}
                            >
                                <FontAwesomeIcon icon={faPrint} />
                                <span className="ozlistui-btn-text">{translations.print || 'Print'}</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Summary Cards */}
                <div className="ozlistui-summary-cards">
                    <div className="ozlistui-summary-card">
                        <div className="ozlistui-summary-icon" style={{ background: '#3b82f620', color: '#3b82f6' }}>
                            <FontAwesomeIcon icon={faBoxes} />
                        </div>
                        <div className="ozlistui-summary-info">
                            <h3>{stockData.length}</h3>
                            <p>{translations.totalProducts || 'Total Products'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-summary-card">
                        <div className="ozlistui-summary-icon" style={{ background: '#10b98120', color: '#10b981' }}>
                            <FontAwesomeIcon icon={faArrowUp} />
                        </div>
                        <div className="ozlistui-summary-info">
                            <h3>{totalPurchaseQty.toFixed(2)}</h3>
                            <p>{translations.totalPurchases || 'Total Purchases'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-summary-card">
                        <div className="ozlistui-summary-icon" style={{ background: '#f59e0b20', color: '#f59e0b' }}>
                            <FontAwesomeIcon icon={faArrowDown} />
                        </div>
                        <div className="ozlistui-summary-info">
                            <h3>{totalSaleQty.toFixed(2)}</h3>
                            <p>{translations.totalSales || 'Total Sales'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-summary-card">
                        <div className="ozlistui-summary-icon" style={{ background: '#8b5cf620', color: '#8b5cf6' }}>
                            <FontAwesomeIcon icon={faUndo} />
                        </div>
                        <div className="ozlistui-summary-info">
                            <h3>{totalReturnQty.toFixed(2)}</h3>
                            <p>{translations.totalReturns || 'Total Returns'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-summary-card">
                        <div className="ozlistui-summary-icon" style={{ background: '#ef444420', color: '#ef4444' }}>
                            <FontAwesomeIcon icon={faBox} />
                        </div>
                        <div className="ozlistui-summary-info">
                            <h3>{totalAvailableStock.toFixed(2)}</h3>
                            <p>{translations.availableStock || 'Available Stock'}</p>
                        </div>
                    </div>
                </div>

                {/* Stock Report Table */}
                <div className="ozlistui-table-scroll">
                    <div className="ozlistui-table-container">
                        <div className="ozlistui-table-wrapper">
                            <table className="ozlistui-table">
                                <thead>
                                    <tr>
                                        <th className="ozlistui-id-column ozlistui-centered-cell">{translations.srNo || 'Sr#'}</th>
                                        <th className="ozlistui-centered-cell">{translations.productName || 'Product Name'}</th>
                                        <th className="ozlistui-centered-cell">{translations.batchNo || 'Batch No'}</th>
                                        <th className="ozlistui-centered-cell">{translations.productCode || 'Product Code'}</th>
                                        <th className="ozlistui-centered-cell">{translations.purchaseQty || 'Purchase Qty'}</th>
                                        <th className="ozlistui-centered-cell">{translations.saleQty || 'Sale Qty'}</th>
                                        <th className="ozlistui-centered-cell">{translations.returnQty || 'Return Qty'}</th>
                                        <th className="ozlistui-centered-cell">{translations.availableStock || 'Available Stock'}</th>
                                        <th className="ozlistui-centered-cell">{translations.unit || 'Unit'}</th>
                                        <th className="ozlistui-centered-cell">{translations.status || 'Status'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pagination.currentData.map((item, index) => {
                                        const status = getStockStatus(item.available_stock, 5);
                                        return (
                                            <tr key={index}>
                                                <td className="ozlistui-id-cell ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{pagination.startIndex + index + 1}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text ozlistui-product-name">{item.product_name || '-'}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{item.batch_no || '-'}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{item.product_code || item.barcode || '-'}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text" style={{ color: '#3b82f6', fontWeight: 'bold' }}>
                                                        {parseFloat(item.purchase_qty || 0).toFixed(2)}
                                                    </span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text" style={{ color: '#f59e0b', fontWeight: 'bold' }}>
                                                        {parseFloat(item.sale_qty || 0).toFixed(2)}
                                                    </span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text" style={{ color: '#8b5cf6', fontWeight: 'bold' }}>
                                                        {parseFloat(item.return_qty || 0).toFixed(2)}
                                                    </span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className={`ozlistui-cell-text ${status.status === 'out-of-stock' ? 'ozlistui-out-of-stock' : status.status === 'low-stock' ? 'ozlistui-low-stock' : ''}`}
                                                          style={{ fontWeight: 'bold' }}>
                                                        {parseFloat(item.available_stock || 0).toFixed(2)}
                                                    </span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{item.unit_of_measure || 'piece'}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-stock-badge" style={{ backgroundColor: status.color + '20', color: status.color }}>
                                                        {status.text}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#f8fafc' }}>
                                        <td colSpan="4" style={{ textAlign: 'right', padding: '10px' }}>{translations.totals || 'TOTALS'}</td>
                                        <td className="ozlistui-centered-cell" style={{ color: '#3b82f6' }}>
                                            {stockData.reduce((sum, item) => sum + (item.purchase_qty || 0), 0).toFixed(2)}
                                        </td>
                                        <td className="ozlistui-centered-cell" style={{ color: '#f59e0b' }}>
                                            {stockData.reduce((sum, item) => sum + (item.sale_qty || 0), 0).toFixed(2)}
                                        </td>
                                        <td className="ozlistui-centered-cell" style={{ color: '#8b5cf6' }}>
                                            {stockData.reduce((sum, item) => sum + (item.return_qty || 0), 0).toFixed(2)}
                                        </td>
                                        <td className="ozlistui-centered-cell" style={{ color: '#ef4444', fontWeight: 'bold' }}>
                                            {stockData.reduce((sum, item) => sum + (item.available_stock || 0), 0).toFixed(2)}
                                        </td>
                                        <td colSpan="2"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Pagination */}
                {stockData.length > itemsPerPage && (
                    <div className="ozlistui-pagination">
                        <div className="ozlistui-pagination-info">
                            <span>{translations.showing || 'Showing'} {pagination.startIndex + 1} {translations.of || 'of'} {stockData.length} {translations.totalProducts || 'products'}</span>
                        </div>
                        <div className="ozlistui-pagination-controls">
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="ozlistui-pagination-btn">
                                <FontAwesomeIcon icon={faChevronLeft} />
                                <span>{translations.previous || 'Previous'}</span>
                            </button>
                            <div className="ozlistui-page-numbers">
                                {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                                    let pageNum;
                                    if (pagination.totalPages <= 5) {
                                        pageNum = i + 1;
                                    } else if (currentPage <= 3) {
                                        pageNum = i + 1;
                                    } else if (currentPage >= pagination.totalPages - 2) {
                                        pageNum = pagination.totalPages - 4 + i;
                                    } else {
                                        pageNum = currentPage - 2 + i;
                                    }
                                    return (
                                        <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`ozlistui-page-number ${currentPage === pageNum ? 'ozlistui-active' : ''}`}>
                                            {pageNum}
                                        </button>
                                    );
                                })}
                            </div>
                            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === pagination.totalPages} className="ozlistui-pagination-btn">
                                <span>{translations.next || 'Next'}</span>
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </div>
                    </div>
                )}
            </>
        );
    };

    // ============================================
    // MAIN RENDER
    // ============================================
    return (
        <div className={`ozlistui-container ${isRTL ? 'ozlistui-rtl' : 'ozlistui-ltr'} ${darkMode ? 'ozlistui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <div className="ozlistui-sticky-header">
                <div className="ozlistui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozlistui-header-content">
                    <div className="ozlistui-header-left">
                        <div className="ozlistui-header-title">
                            <h1>{translations.stockReport || 'Stock Report'}</h1>
                            <p>
                                {currentShop?.shop_name || translations.stockReportDetails || 'Stock Report Details'}
                                {currentShop?.shop_code && ` (${currentShop.shop_code})`}
                            </p>
                        </div>
                    </div>
                    <div className="ozlistui-header-right">
                        {!currentShop && (
                            <button className="ozlistui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                <span>{translations.switchShop || 'Switch Shop'}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {renderContent()}
        </div>
    );
};

export default StockReport;